import client from './client';

export const listUsers = () => client.get('/users').then((r) => r.data);
export const myStaff = () => client.get('/users/my-staff').then((r) => r.data);
export const scopeUsers = () => client.get('/users/scope').then((r) => r.data);
export const createUser = (payload) => client.post('/users', payload).then((r) => r.data);
export const updateUserFull = (id, payload) => client.put(`/users/${id}/full`, payload).then((r) => r.data);
export const removeUser = (id) => client.delete(`/users/${id}`).then((r) => r.data);
export const listDepartments = () => client.get('/users/departments').then((r) => r.data);
export const updateDepartments = (id, departments) =>
  client.put(`/users/${id}/departments`, { departments }).then((r) => r.data);
export const updateSalary = (id, payload) =>
  client.put(`/users/${id}/salary`, payload).then((r) => r.data);
export const updateSyncAgent = (id, syncAgent) =>
  client.put(`/users/${id}/sync-agent`, { syncAgent }).then((r) => r.data);
export const updateContact = (id, payload) =>
  client.put(`/users/${id}/contact`, payload).then((r) => r.data);
export const resetPassword = (id) =>
  client.put(`/users/${id}/reset-password`).then((r) => r.data);
export const salesHeads = () => client.get('/users/sales-heads').then((r) => r.data);
export const listDeptHeads = () => client.get('/users/dept-heads').then((r) => r.data);
export const setDeptHead = (department, userId) =>
  client.put('/users/dept-head', { department, userId }).then((r) => r.data);
// Đánh dấu ĐÃ NGHỈ VIỆC / quay lại làm việc (GĐ). Đã nghỉ = chặn đăng nhập + chat hiện "đã nghỉ việc".
export const setUserResigned = (id, resigned) => client.put(`/users/${id}/resigned`, { resigned }).then((r) => r.data);
// Tài khoản ĐỐI TÁC (role=DT): tạo mới + đổi danh sách người được chat. Chỉ GĐ/CV.
export const createPartner = (payload) => client.post('/users/partner', payload).then((r) => r.data);
export const setPartnerContacts = (id, contacts) => client.put(`/users/${id}/partner-contacts`, { contacts }).then((r) => r.data);
